import { RoleRule, ROLE_RULES } from './role-rule';
import { Permissions } from './permission-def';
import { Roles } from "./role-def";
import { map, pipe, tap } from 'rxjs';
import { AuthPipe, customClaims } from '@angular/fire/compat/auth-guard';
import { intersection } from 'lodash';
import { AuthService } from 'projects/admin/src/app/core/services/auth.service';
import { UserModel } from '@shared/models/user.model';



export const userRoleRules = (userRoles: Roles[]): RoleRule[] => ROLE_RULES.filter(role_rule => userRoles.includes(role_rule.role));

export const hasPermissions = (permissionRoles: Roles[] | Permissions[], userRolesRules: RoleRule[]) =>
  userRolesRules.find(userRoleRule =>
    (permissionRoles as Roles[]).includes(userRoleRule.role) ||
    permissionRoles.some(permissionRole => userRoleRule.permissions.includes(permissionRole as any))
  );

export const onlyPermissions = (permissionRoles: Roles | Roles[] | Permissions | Permissions[] | null) =>
  () => pipe(customClaims, map(claims =>
    !!hasPermissions(permissionRoles as Roles[], userRoleRules(claims?.roles))
  ));

export const defaultRolePath = (userRoles: Roles[] = []): string => userRoleRules(userRoles)?.[0]?.defaultPath;

// this returns an UnaryFunction that returns an AuthPipe, to be called like this: { path: '', pathMatch: 'full', ...canActivate(redirectToDefaultPath('some-path')) },
export const redirectToDefaultPath = (redirect: string | any[]) => () => pipe(customClaims, map(claims => defaultRolePath(claims?.roles) ?? redirect)) as AuthPipe;



/*** Integrar */
//TODO
const Redirects = {
  Login: ['/home'],
  Home: ['/'],
};
const validateOrRedirect = (cond, redirect = undefined) => cond ? true : (redirect ?? Redirects.Home);

// auth pipes:
export const redirectUnauthorizedToLogin = () => pipe(
  customClaims,
  map(claims => validateOrRedirect(intersection(claims?.roles ?? [], AuthService.AllowedRoles).length > 0, Redirects.Login)),
  // tap(c => console.log('GUARD redirectUnauthorizedToLogin', c)),
);

export const adminOnly = () => pipe(
  customClaims,
  map(claims => validateOrRedirect(claims?.roles?.includes(UserModel.AdminRole))),
  // tap(c => console.log('GUARD adminOnly', c)),
);

export const authorizedLogged = () => pipe(
  customClaims,
  map(claims => validateOrRedirect(!!intersection(claims?.roles ?? [], AuthService.AllowedRoles).length)),
);
// export const providerOnly = () => pipe(
//   customClaims,
//   map(claims => validateOrRedirect(claims?.roles?.includes(UserModel.Role.PROVIDER))),
//   tap(c => console.log('GUARD providerOnly', c)),
// );








// this returns an AuthPipe, to be called like this: { path: '', pathMatch: 'full', ...canActivate(() => redirectToDefaultPath2('some-path')) },
// export const redirectToDefaultPath2: (redirect: string|any[]) => AuthPipe = (redirect: string|any[]) => pipe(customClaims, map(claims => defaultRolePath(claims?.roles) ?? redirect));



// export const filterRolesOfClaims = (roles:Roles[]) : Roles[] => roles?.length > 0 ? roles.filter(cr => ROLE_RULES.find(R => R.role == cr)) ?? []  : [];
// export const matchRoles = (roles1: Roles[], roles2: Roles[] ): boolean =>{
//   return roles1.some(_r1 => roles2.includes(_r1));
// }

// export const matchRolePermissions = (r1: Roles[], p2: Permissions[] ): boolean =>{
//   return ROLE_RULES.some( r => r1.includes(r.role) && p2.find(_p2 => r.permissions.includes(_p2)));
// }

// export const matchRoleOrPermission = (roles: Roles[], arr: string[]):boolean=>{
//   return matchRoles(roles, arr as any) || matchRolePermissions(roles, arr as any);
// }

/*
  export const onlyPermissions = (permissionRoles: Roles | Roles[] | Permissions | Permissions[] | null) => () => pipe(customClaims, map(claims =>
  {
    // const filteredRoles = filterRolesOfClaims(claims?.roles);
    // if(data?.only) return matchRoleOrPermission(filteredRoles, data.only as any);
  }
*/

